"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFrontConfig = exports.KYC_STATUS = void 0;
__exportStar(require("./auth"), exports);
__exportStar(require("./balance"), exports);
__exportStar(require("./bonuses"), exports);
var config_1 = require("./config");
Object.defineProperty(exports, "KYC_STATUS", { enumerable: true, get: function () { return config_1.KYC_STATUS; } });
__exportStar(require("./countries"), exports);
__exportStar(require("./country"), exports);
__exportStar(require("./currencies"), exports);
__exportStar(require("./deposit"), exports);
__exportStar(require("./documents"), exports);
__exportStar(require("./email"), exports);
__exportStar(require("./games"), exports);
__exportStar(require("./geo"), exports);
__exportStar(require("./glp"), exports);
__exportStar(require("./jackpot"), exports);
__exportStar(require("./limits"), exports);
__exportStar(require("./lottery"), exports);
__exportStar(require("./loyalty"), exports);
__exportStar(require("./manager"), exports);
__exportStar(require("./pages"), exports);
__exportStar(require("./payIn"), exports);
__exportStar(require("./payOut"), exports);
__exportStar(require("./phone"), exports);
__exportStar(require("./promo"), exports);
__exportStar(require("./promocode"), exports);
__exportStar(require("./providers"), exports);
__exportStar(require("./session"), exports);
__exportStar(require("./state"), exports);
__exportStar(require("./tournaments"), exports);
__exportStar(require("./transactions"), exports);
__exportStar(require("./translations"), exports);
__exportStar(require("./useCache"), exports);
__exportStar(require("./useConfig"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./userGames"), exports);
__exportStar(require("./wheel"), exports);
__exportStar(require("./withdrawal"), exports);
__exportStar(require("./limits"), exports);
__exportStar(require("./jackpot"), exports);
__exportStar(require("./phone"), exports);
__exportStar(require("./lottery"), exports);
__exportStar(require("./state"), exports);
__exportStar(require("./texts"), exports);
__exportStar(require("./brand"), exports);
__exportStar(require("./report"), exports);
__exportStar(require("./betting"), exports);
__exportStar(require("./referral"), exports);
var config_2 = require("./config");
Object.defineProperty(exports, "useFrontConfig", { enumerable: true, get: function () { return config_2.useFrontConfig; } });
